'use client';

import dynamic from 'next/dynamic';
import { useIsDealershipPage } from '~/context/dealership/StaticContext';

const CarvanaPageFooter = dynamic(
  () => import(/* webpackChunkName: "PageFooter" */ './CarvanaPageFooter')
);

const DealershipPageFooter = dynamic(
  () =>
    import(
      /* webpackChunkName: "DealershipPageFooter" */ '@/dealership/PageFooter'
    )
);

type OwnProps = {
  className?: string;
};

export default function PageFooter({ className }: OwnProps) {
  const isDealership = useIsDealershipPage();

  return isDealership ? (
    <DealershipPageFooter />
  ) : (
    <CarvanaPageFooter className={className} />
  );
}
